import type { AnchorStrategyUpdateModel } from '@/shared/generated'

import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'

import { useUpdateAnchorStrategyMutation } from '@/entities/anchor'

import { queryClient } from '@/shared/lib/query-client'
import { processingMessage } from '@/shared/tools/message'

export function useUpdateAnchorStrategy(onSuccess?: () => void) {
	const { t } = useTranslation()

	const updateAnchorStrategyMutation = useUpdateAnchorStrategyMutation({
		onSuccess: (data) => {
			onSuccess?.()
			queryClient.invalidateQueries({
				queryKey: ['anchors-strategies'],
			})
			queryClient.invalidateQueries({
				queryKey: ['anchoring-strategy', data.id],
			})
			queryClient.invalidateQueries({
				queryKey: ['generated-anchor-families'],
			})
		},
	})
	const handleUpdateStrategy = (
		data: AnchorStrategyUpdateModel & { id: string }
	) => {
		toast.promise(updateAnchorStrategyMutation.mutateAsync(data), {
			loading: processingMessage(t),
			success: t('toast.entity.updated', {
				entity: t('entity.anchor_strategy'),
			}),
			error: t(
				'anchoring_management.strategy_page.update_anchor_strategy_error'
			),
			id: 'anchor_strategy_updating',
		})
	}

	return {
		handleUpdateStrategy,
		isPending: updateAnchorStrategyMutation.isPending,
	}
}
